export default __webpack_public_path__ + "static/contentful-dark-319e009708547995795a7cd24442f3d0.png";